import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import BrandDetailDE from './BrandDetailDE';
import BrandDetailUS from './BrandDetailUS';
import { useAuthContext } from '@/contexts';

const BrandDetail = () => {
  const { profile } = useAuthContext();
  const { id: brandUid } = useParams<{ id: string }>();

  const Page = useMemo(() => {
    if (profile?.market === 'DE') {
      return BrandDetailDE;
    }
    return BrandDetailUS;
  }, [profile?.market]);

  return <Page brandUid={brandUid} />;
};

export default BrandDetail;
